export default {
  rentals: [
    "$500",
    "$750",
    "$1,000",
    "$1,250",
    "$1,500",
    "$1,750",
    "$2,000",
    "$2,500",
    "$3,000",
    "$3,500",
    "$4,000",
    "$4,500",
    "$5,000",
    "$6,000",
    "$7,000",
    "$8,000",
    "$9,000",
    "$10,000",
    "$12,500",
    "$15,000"
  ],
  sales: [
    "$100,000",
    "$150,000",
    "$200,000",
    "$250,000",
    "$300,000",
    "$400,000",
    "$500,000",
    "$600,000",
    "$700,000",
    "$800,000",
    "$900,000",
    "$1,000,000",
    "$1,250,000",
    "$1,500,000",
    "$1,750,000",
    "$2,000,000",
    "$2,250,000",
    "$2,500,000",
    "$2,750,000",
    "$3,000,000",
    "$3,500,000",
    "$4,000,000",
    "$4,500,000",
    "$5,000,000",
    "$6,000,000",
    "$7,000,000",
    "$8,000,000",
    "$9,000,000",
    "$10,000,000",
    "$12,000,000",
    "$14,000,000",
    "$16,000,000",
    "$20,000,000",
    "$25,000,000",
    "$30,000,000"
  ]
};
